import React from "react";
import classes from "./TagInputFake.module.scss";

const TagInputFake = ({
  centerText = false,
  className = "",
  label = null,
  msgInfo = false,
  name = "",
  parentClass = null,
  value = "",
}) => {
  const inputeCenterClass = centerText ? " " + classes.CenterText : "";
  className = className ? " " + className : "";

  let finalInput = (
    <>
      {label && (
        <label className={classes.Label} htmlFor={"id_" + [name]}>
          {label}
        </label>
      )}
      <p className={classes.TagInputFake + className + inputeCenterClass}>
        {value}
      </p>
    </>
  );
  if (parentClass) {
    finalInput = <div className={parentClass}> {finalInput}</div>;
  }
  return finalInput;
};

export default TagInputFake;
